import React from "react"

const Clickable = React.forwardRef(
  ({ appNavTo, href, children, interactivity, ...props }, ref) => {
    const target = appNavTo || href

    return (
      <a
        {...props}
        ref={ref}
        href={target}
        interactivity={interactivity ? "true" : undefined}
      >
        {children}
      </a>
    )
  }
)

Clickable.displayName = "Clickable"

export default Clickable
